/* import __COLOCATED_TEMPLATE__ from './campaign-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import Component from '@glimmer/component';

type BannerVariant = 'paywall' | 'success';

const VARIANT_CLASSES: Record<BannerVariant, string> = {
  paywall: 'border-paywall-border bg-paywall-container',
  success: 'border-success-border bg-success-container',
};

interface Signature {
  Element: HTMLDivElement;
  Args: {
    bannerText: string;
    bannerCtaText?: string;
    onCtaClick?: () => void;
    variant?: BannerVariant;
  };
}

export default class CampaignBanner extends Component<Signature> {
  get variantClasses(): string {
    return VARIANT_CLASSES[this.args.variant ?? 'paywall'];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::CampaignBanner': typeof CampaignBanner;
    'banners/campaign-banner': typeof CampaignBanner;
  }
}
